import React from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';
import Highlight from 'components/Highlight';

const _AddressItem = ({ id, text, description, type, highlight, onClick }) => {
  const addressItemClassName = cc([
    'dropdown__option dropdown__address',
    type !== 'Address' && 'dropdown__address--expanded'
  ]);
  const highlighter = highlight.split(';');

  return (
    <span
      className={addressItemClassName}
      onClick={onClick}
      data-__value={id}
      data-test-id={`address-${text}`}
    >
      {text && (
        <span className="dropdown__address__lines">
          <Highlight range={highlighter[0]}>{text}</Highlight>
        </span>
      )}
      {description && (
        <span className="dropdown__address__city">
          <Highlight range={highlighter[1]}>{description}</Highlight>
        </span>
      )}
    </span>
  );
};

_AddressItem.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  highlight: PropTypes.string,
  onClick: PropTypes.func
};

_AddressItem.defaultProps = {
  id: null,
  text: null,
  description: null,
  type: 'Address',
  highlight: '',
  onClick: null
};

export default _AddressItem;
